class PrescriptionHelper {
    /**
     * Get whether a prescription was prescribed by an external professional.
     * @param externalPrescriberDisplayName The display name of the external prescriber. An empty string indicates an unspecified external prescriber; a null value indicates an internal prescriber.
     */
    public static IsPrescribedExternally(externalPrescriberDisplayName: string | null): boolean {
        return !IsNullOrUndefined(externalPrescriberDisplayName);
    }
}

export { PrescriptionHelper };
